import { ETechnicalAssistancesActions, TechnicalAssistancesActions } from "@edp-store/actions/technical-assistances.actions";
import { initialTechnicalAssistancesState, ITechnicalAssistancesState } from "@edp-store/state/technical-assistances.state";

export function technicalAssistancesReducers(
    state = initialTechnicalAssistancesState, action: TechnicalAssistancesActions): ITechnicalAssistancesState {
    switch (action.type) {
        case ETechnicalAssistancesActions.SetTechnicalAssistances: {
            return {
                ...state,
                technicalAssistances: {
                    data: action.payload,
                    lastAPIError: null
                }
            };
        }
        case ETechnicalAssistancesActions.TechnicalAssistancesAPIError: {
            return {
                ...state,
                technicalAssistances: {
                    ...state.technicalAssistances,
                    lastAPIError: action.error
                }
            };
        }
        default: {
            return state;
        }
    }
}
